const proc = process;
const isProd = proc.env.isProd;
//export const config = { "baseUrl" : isProd ? "http://34.154.220.24:8080/" : "http://localhost:8080/" }
export const config = { "baseUrl": isProd ? "https://manleve.guglielmo.biz/api/" : "http://localhost:8080/" };
